import { Injectable } from '@angular/core';
import {LocalStorageService} from './LocalStorageService';

@Injectable()
export class MusicCollectionSettingsService {

  private static readonly ARTIST_SORT_VIEW_LOCAL_STORAGE_KEY = 'mikebgrove-musiccollection.artistSortView';

  /*
    the valid values for the ARTIST_SORT_VIEW_LOCAL_STORAGE_KEY setting above
   */
  public static readonly ARTIST_SORT_ALPHABETICAL = 'ALPHABETICAL';
  public static readonly ARTIST_SORT_ALBUM_COUNT = 'ALBUM_COUNT';

  private static readonly ALBUM_SORT_VIEW_LOCAL_STORAGE_KEY = 'mikebgrove-musiccollection.albumSortView';

  /*
    the valid values for the ALBUM_SORT_VIEW_LOCAL_STORAGE_KEY setting above
   */

  public static readonly ALBUM_SORT_ALPHABETICAL_BY_ARTIST_NAME_THEN_CHRONOLOGICAL = 'ALPHABETICAL_BY_ARTIST_NAME_THEN_CHRONOLOGICAL';
  public static readonly ALBUM_SORT_ARTIST_ALBUM_COUNT_THEN_CHRONOLOGICAL = 'ARTIST_ALBUM_COUNT_THEN_CHRONOLOGICAL';
  public static readonly ALBUM_SORT_REVIEW_DATE_DESCENDING = 'REVIEW_DATE_DESCENDING';
  public static readonly ALBUM_SORT_RATING_ASCENDING = 'RATING_ASCENDING';
  public static readonly ALBUM_SORT_RATING_DESCENDING = 'RATING_DESCENDING';
  public static readonly ALBUM_SORT_YEAR_ASCENDING = 'YEAR_ASCENDING';
  public static readonly ALBUM_SORT_YEAR_DESCENDING = 'YEAR_DESCENDING';

  private static readonly ALBUM_VIEW_LOCAL_STORAGE_KEY = 'mikebgrove-musiccollection.albumView';

  /*
    the valid values for ALBUM_VIEW_LOCAL_STORAGE_KEY
   */
  public static readonly CARD = 'CARD';
  public static readonly TABLE = 'TABLE';

  constructor(
    private localStorageService: LocalStorageService) {
  }

  getArtistSortViewFromLocalStorage(defaultIfUnsetOrInvalid: string): string {
    let artistSortView: string;
    const storedArtistSortView: string = this.localStorageService.getPropertyValue(
      MusicCollectionSettingsService.ARTIST_SORT_VIEW_LOCAL_STORAGE_KEY);
    switch (storedArtistSortView) {
      case MusicCollectionSettingsService.ARTIST_SORT_ALPHABETICAL:
      case MusicCollectionSettingsService.ARTIST_SORT_ALBUM_COUNT:
        console.log('retrieved artist sort view of ' + storedArtistSortView + ' from local storage');
        artistSortView = storedArtistSortView;
        break;
      default:
        console.log('did not find artist sort view in local storage, using default of ' + defaultIfUnsetOrInvalid);
        artistSortView = defaultIfUnsetOrInvalid;
    }
    return artistSortView;
  }

  public storeArtistSortViewInLocalStorage(artistSortView: string): void {
    console.log('Storing artist sort view of ' + artistSortView + ' in local storage');
    this.localStorageService.savePropertyValue(MusicCollectionSettingsService.ARTIST_SORT_VIEW_LOCAL_STORAGE_KEY, artistSortView);
  }

  getAlbumSortViewFromLocalStorage(defaultIfUnsetOrInvalid: string): string {
    let albumSortView: string;
    const storedAlbumSortView: string = this.localStorageService.getPropertyValue(
      MusicCollectionSettingsService.ALBUM_SORT_VIEW_LOCAL_STORAGE_KEY);
    switch (storedAlbumSortView) {
      case MusicCollectionSettingsService.ALBUM_SORT_ALPHABETICAL_BY_ARTIST_NAME_THEN_CHRONOLOGICAL:
      case MusicCollectionSettingsService.ALBUM_SORT_ARTIST_ALBUM_COUNT_THEN_CHRONOLOGICAL:
      case MusicCollectionSettingsService.ALBUM_SORT_REVIEW_DATE_DESCENDING:
      case MusicCollectionSettingsService.ALBUM_SORT_RATING_ASCENDING:
      case MusicCollectionSettingsService.ALBUM_SORT_RATING_DESCENDING:
      case MusicCollectionSettingsService.ALBUM_SORT_YEAR_ASCENDING:
      case MusicCollectionSettingsService.ALBUM_SORT_YEAR_DESCENDING:
        console.log('retrieved album sort view of ' + storedAlbumSortView + ' from local storage');
        albumSortView = storedAlbumSortView;
        break;
      default:
        console.log('did not find album sort view in local storage, using default of ' + defaultIfUnsetOrInvalid);
        albumSortView = defaultIfUnsetOrInvalid;
    }
    return albumSortView;
  }

  public storeAlbumSortViewInLocalStorage(albumSortView: string): void {
    console.log('Storing album sort view of ' + albumSortView + ' in local storage');
    this.localStorageService.savePropertyValue(MusicCollectionSettingsService.ALBUM_SORT_VIEW_LOCAL_STORAGE_KEY, albumSortView);
  }

  public getAlbumViewFromLocalStorage(defaultIfUnsetOrInvalid: string): string {
    let albumView: string;
    const storedAlbumView: string = this.localStorageService.getPropertyValue(MusicCollectionSettingsService.ALBUM_VIEW_LOCAL_STORAGE_KEY);
    switch (storedAlbumView) {
      case MusicCollectionSettingsService.CARD:
      case MusicCollectionSettingsService.TABLE:
        console.log('retrieved album view of ' + storedAlbumView + ' from local storage');
        albumView = storedAlbumView;
        break;
      default:
        console.log('did not find album view in local storage, using default of ' + defaultIfUnsetOrInvalid);
        albumView = defaultIfUnsetOrInvalid;
    }
    return albumView;
  }

  public storeAlbumViewInLocalStorage(albumView: string): void {
    console.log('Storing album view of ' + albumView + ' in local storage');
    this.localStorageService.savePropertyValue(MusicCollectionSettingsService.ALBUM_VIEW_LOCAL_STORAGE_KEY, albumView);
  }

}
